/**
 * ContratsBatimentsPage — contrats & baux des bâtiments (item 7.5).
 *
 * Rattachée au service technique, comme les visites ERP : c'est le même parc
 * bâtimentaire. Le comptable, lui, y accède depuis sa propre brique — même
 * écran, mêmes données, sans jamais recevoir de permission `service_technique.*`.
 */
import { AppHeader } from '@/components/AppHeader';
import { ServiceTechniqueNav } from '@/components/ServiceTechniqueNav';
import { ContratsBatimentsPanel } from './ContratsBatimentsPanel';

export function ContratsBatimentsPage() {
  return (
    <>
      <AppHeader module="Service technique" accent="tech" />
      <ServiceTechniqueNav active="contrats" />
      <main id="main-content" className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
        <ContratsBatimentsPanel />
      </main>
    </>
  );
}
